import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input, Dropdown, MenuItem } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

export class ESLModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ESLCode: '',
            TemplateId: '',
            TemplateName: '',

            templateOptions: [],
            templateOptionsDisplay: <Translate value="select" />,
        };
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
    }

    componentDidMount() {
        let templateOptions = [];
        this.props.fetchESLTemplate()
            .then((response) => {
                response.data.template_list.map(templates => {
                    templateOptions.push({ value: templates.template_id, label: templates.template_name })
                });
                this.setState({ templateOptions });
            }, (err) => {
                alert("ESL Error: " + err.data);
            });

        this.props.handleFetchESL(); // fetch data
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.eslFetchData) {
            this.setState({
                ESLCode: nextProps.eslFetchData.ESLCode,
                TemplateId: nextProps.eslFetchData.TemplateId,
                TemplateName: nextProps.eslFetchData.TemplateName,
            });
        }
    }

    handleTemplateChange = (el) => {
        this.setState({
            templateOptionsDisplay: el.label,
            TemplateId: el.value,
            TemplateName: el.label,
        });
    }

    handleCodeChange = (value) => {
        this.setState({ ESLCode: value })
    }

    handleConfirmClick() {
        if (!this.state.TemplateId) {
            alert("Please choose an ESL template");
        } else if (!this.state.ESLCode) {
            alert("Please enter an ESL Code");
        } else {
            this.props.handleSaveESL(this.state.ESLCode, this.state.TemplateId, this.state.TemplateName);
        }
    }

    render() {
        const templateOptions = this.state.templateOptions;
        return (
            <div>
                <Row>
                    <Col xs={12} className="centerStyle">
                        <label><Translate value="esl_template" /></label>
                    </Col>
                    <Col xs={12} className="centerStyle" style={{ marginTop: '5px', marginBottom: '10px' }}>
                        <Dropdown>
                            <Dropdown.Toggle style={{ width: '300px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                                {this.state.templateOptionsDisplay}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="super-colors">
                                {templateOptions.map(el => {
                                    return (
                                        <MenuItem onClick={() => this.handleTemplateChange(el)}>{el.label}</MenuItem>
                                    )
                                })}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>

                    <Col xs={12} className="centerStyle">
                        <label><Translate value="esl_code" /></label>
                    </Col>
                    <Col xs={12} className="centerStyle" style={{ marginTop: '5px', marginBottom: '10px' }}>
                        <Input
                            type="text"
                            style={{ width: '250px' }}
                            value={this.state.ESLCode}
                            onChange={(e) => this.handleCodeChange(e.target.value)}
                        />
                    </Col>

                    <Col xs={12} className="centerStyle">
                        <Button
                            bsStyle="success"
                            onClick={this.handleConfirmClick}
                        >
                            <em className="fa fa-check" /><Translate value="confirm" />
                        </Button>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ESLModal



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/ESLModal.jsx